<re-captcha #captchaRef="reCaptcha" (resolved)="captchaResolved($event)" size="invisible" (error)="captchaError()" [siteKey]="captchaSiteKey" errorMode="handled"></re-captcha>
